import apiService from './api-service';

const Syllabus = {};
const urlEntity = "/syllabus";

Syllabus.all = (q = null, limit = null, page = null) => {
    if (q) {
        q.limit = limit;
        q.page = page;
    } else {
        q = {};
        q.limit = limit;
        q.page = page;
    }
    return apiService.get(urlEntity, {
        params: q,
    })
        .then((res) => res)
};

Syllabus.getOne = (id) => {
    return apiService.get(`${urlEntity}/${id}`)
        .then((res) => res)
};

Syllabus.add = (data) => {
    return apiService.post(urlEntity, data)
        .then((res) => res)
};

Syllabus.edit = (id, data) => {
    return apiService.put(`${urlEntity}/${id}`, data)
        .then((res) => res)
};

Syllabus.delete = (id) => {
    return apiService.delete(`${urlEntity}/${id}`)
        .then((res) => res)
};

Syllabus.existDescription = (description = null, currentDescription = null) => {
    var q = {};
    if (description) {
        q.description = description;
    }
    if (currentDescription) {
        q.current_description = currentDescription;
    }
    return apiService.get(`${urlEntity}/exist-description`, {
        params: q,
    })
        .then((res) => res);
};

Syllabus.existVersion = (version = null, currentVersion = null) => {
    var q = {};
    if (version) {
        q.version = version;
    }
    if (currentVersion) {
        q.current_version = currentVersion;
    }
    return apiService.get(`${urlEntity}/exist-version`, {
        params: q,
    })
        .then((res) => res);
};

Syllabus.selectAll = (query = {}) => {
    return apiService.get(`${urlEntity}/select-all`, {
        params: query,
    })
        .then((res) => res);
};

Syllabus.selectAllStudentSyllabus = (query = {}) => {
    return apiService.get(`${urlEntity}/select-all-student-syllabus`, {
        params: query,
    })
        .then((res) => res);
};

export default Syllabus;
